import { Refresh } from '@mui/icons-material';
import { QueryKey, useQueryClient } from '@tanstack/react-query';
import React from 'react';
import Button from 'src/view/components/button/Button';
import TableHeader from 'src/view/components/table/table-header/TableHeader';

export interface TableRefreshHeaderFeatureProps {
    title?: string;
    queryKeys: QueryKey[];
}

export default function TableRefreshHeaderFeature(
    props: Readonly<TableRefreshHeaderFeatureProps>
): React.ReactElement {
    const queryClient = useQueryClient();

    return (
        <TableHeader
            title={props.title ?? ''}
            rightSlot={
                <Button
                    disableRipple={false}
                    onClick={() => {
                        props.queryKeys.forEach((key) => {
                            queryClient.invalidateQueries(key).then((_) => {});
                        });
                    }}
                    endIcon={<Refresh />}
                >
                    Refresh
                </Button>
            }
        />
    );
}
